import { render, staticRenderFns } from "./ZiXuanEdit.vue?vue&type=template&id=1ae38c18&scoped=true&"
import script from "./ZiXuanEdit.vue?vue&type=script&lang=js&"
export * from "./ZiXuanEdit.vue?vue&type=script&lang=js&"
import style0 from "./ZiXuanEdit.vue?vue&type=style&index=0&id=1ae38c18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae38c18",
  null
  
)

export default component.exports